import {Component, Vue, Prop} from 'vue-facing-decorator';
import { ref } from "vue";


import GlobalSearch from '@/components/GlobalSearch/GlobalSearch.vue';
import UserMenu     from '@/components/UserMenu/UserMenu.vue';
import SubMenu      from '@/components/HeaderMenu/SubMenu/SubMenu.vue';
import NotifMenu    from '@/components/NotifMenu/NotifMenu.vue';

@Component({
    name : 'app-header-menu',
    components: {
        'app-global-search' : GlobalSearch,
        'app-user-menu'     : UserMenu,
        'app-sub-menu'      : SubMenu,
        'app-notif-menu'    : NotifMenu,
    }
})
export default class HeaderMenu extends Vue {
    @Prop() app_base_data = ref([]);
    @Prop() menu_items = ref([]);

    toggleAppSide() {
        this.$store.dispatch('ui/toggleMenuSidebar'); 
    }


}